import React from 'react';

function PaymentOptionsScreen({ onSelectPaymentMethod, onReturnToOrdering }) { 
    const paymentOptions = [
        { method: 'כרטיס אשראי', icon: 'credit.png', style: 'bg-blue-500 hover:bg-blue-600' }, 
        { method: 'ביט', icon: 'bit.png', style: 'bg-purple-500 hover:bg-purple-600' }, 
        { method: 'PayBox', icon: 'paybox.png', style: 'bg-teal-500 hover:bg-teal-600' }, 
        { method: 'מזומן בקופה', icon: 'kash.png', style: 'bg-green-500 hover:bg-green-600' }
    ]; 
    
    return (
        <div className="flex flex-col justify-center items-center py-10" style={{ minHeight: 'calc(100vh - 100px)' }}>
            <div className="w-full max-w-md p-6 bg-gray-800 bg-opacity-90 rounded-lg shadow-xl">
                <h2 className="text-2xl font-bold mb-8 text-amber-400">בחר אפשרות תשלום</h2>
                <div className="space-y-3">
                    {paymentOptions.map(opt => (
                        <button 
                            key={opt.method} 
                            onClick={() => onSelectPaymentMethod(opt.method)} 
                            className={`${opt.style} text-white font-semibold py-3 px-4 rounded-lg w-full flex items-center justify-center text-lg transition-transform transform hover:scale-105`}
                        >
                            <img src={`/${opt.icon}`} alt="" className="w-7 h-7 ms-3 object-contain" />
                            {opt.method}
                        </button>
                    ))}
                </div>
                <button 
                    onClick={onReturnToOrdering} 
                    className="mt-8 bg-gray-600 hover:bg-gray-700 text-white font-bold py-2.5 px-4 rounded-lg w-full text-base transition-colors"
                >
                    חזור לבחירת פריטים
                </button>
            </div>
        </div>
    ); 
}

export default PaymentOptionsScreen; 